// 接口请求路径
const api_url = 'https://api.fgventure.com/admin'; // 正式
// const api_url = 'http://fgventure.api.jeachou.com/admin'; // 测试

import { axios } from "./axios.js";


// oss 
var bucket_url = 'https://fgventure-oss.oss-cn-beijing.aliyuncs.com/';

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

const formatTime = (date, e) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  if (e == 1) {
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  } else if (e == 2) {
    return [year, month, day].map(formatNumber).join('.');
  } else if (e == 3) {
    return [year, month, day].map(formatNumber).join('-');
  } else if (e == 4) {
    return year + '' + month + '' + day
  }
}


const OSS = require("ali-oss");
const myOss = "";

const getOss = async () => {
  if (myOss) return myOss;

  const {
    data: { id, secret },
  } = await axios.post(api_url + "/upload/get_id_secret", {});

  myOss = new OSS({
    accessKeyId: id,
    accessKeySecret: secret,
    bucket: "fgventure-oss",
    region: "oss-cn-beijing",
  });

  return myOss;
};

export default {
  getOss,
  api_url,
  bucket_url,
  formatTime,
};



// WEBPACK FOOTER //
// ./src/util/common.js